import { Field, Form } from "react-final-form";
import type { GameClipIntervalRequest, GameClipEventRequest } from "../../../types";
import "./eventList.css";
import { createIntervalsFromMergedEvents } from "../../../functions";
import { _, _any } from "i18n";
import { useEditStore } from "../../../edit-store";
import { useGameStore } from "../../../store";

interface CreateClipModalProps {
	close: () => void;
	onSubmit: (intervals: GameClipIntervalRequest[], name: string, description?: string) => void;
}

export function CreateClipModal({ close, onSubmit }: CreateClipModalProps) {
	const { setSelectedEvents, selectedEvents } = useEditStore();
	const { setFollowVideo } = useGameStore();

	const validate = (values: { clipName: string; description: string }) => {
		const errors: { clipName?: string } = {};
		if (!values.clipName?.trim()) {
			errors.clipName = _("app.player.profile.position.error");
		}
		return errors;
	};

	const handleFormSubmit = (values: { clipName: string; description: string }) => {
		const data = {
			name: values.clipName,
			description: values.description,
			intervals: createIntervalsFromMergedEvents(selectedEvents).map((interval) => {
				const events: GameClipEventRequest[] = [];

				for (const me of selectedEvents) {
					if (me.startTime >= interval.start && me.endTime <= interval.end) {
						for (const eventId of me.eventIds) {
							events.push({
								id: eventId,
								prepend: me.prependSeconds * 1000,
								append: me.appendSeconds * 1000,
							});
						}
					}
				}

				return {
					start: interval.start,
					end: interval.end,
					events: events,
				};
			}),
		};
		onSubmit(data.intervals, data.name, data.description);
		close();
		setSelectedEvents([]);
		setFollowVideo(true);
	};

	return (
		<div className="createClipModal-container">
			<Form
				onSubmit={handleFormSubmit}
				validate={validate}
				initialValues={{ clipName: "", description: "" }}
				render={({ handleSubmit, submitting, pristine }) => (
					<form onSubmit={handleSubmit} className="createClipModal-form">
						<div className="createClipModal-item">
							<div className="createClipModal-label">{_any("clipModal.create.name")}</div>
							<Field name="clipName">
								{({ input, meta }) => (
									<>
										<input className="clipNameInput" type="text" placeholder={_("clipModal.create.name.placeholder")} {...input} />
										{meta.error && meta.touched && <span className="error">{meta.error}</span>}
									</>
								)}
							</Field>
							<div className="createClipModal-label">{_any("clipModal.create.description")}</div>
							<Field name="description">
								{({ input, meta }) => (
									<>
										<input className="clipNameInput" type="text" placeholder={_("clipModal.create.description.placeholder")} {...input} />
										{meta.error && meta.touched && <span className="error">{meta.error}</span>}
									</>
								)}
							</Field>
						</div>
						<div className="clipCreateContorls">
							<button
								type="button"
								className="clipButton cancel"
								onClick={() => {
									close();
								}}
							>
								{_("btn.cancel")}
							</button>
							<button type="submit" className="clipButton create" disabled={submitting || pristine}>
								{_("label.create_clip")}
							</button>
						</div>
					</form>
				)}
			/>
		</div>
	);
}
